import { useState } from 'react';
import { useParams } from 'react-router-dom';

export const useDashboardController = () => {
	const { dealId } = useParams();

	const [selectedDealId, setSelectedDealId] = useState<string | null>(dealId ?? null);

	return {
		selectedDealId,
		setSelectedDealId,
	};
};
